import PropTypes from 'prop-types';
import classnames from 'classnames';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import { trans } from '@spotahome/soyuz/client';

import Rating from '../Rating';
import CalendarWhiteBlack from '../icons/CalendarWhiteBlack';

import ImageCarousel from '../ImageCarousel';

import { RATIOS } from '../ImageCarousel/utils/constants';

import styles from './HomeSummary.module.scss';

const baseClassName = 'home-summary';

const HomeSummary = ({
  photo = '',
  title = null,
  type = undefined,
  rating = 0,
  className = '',
  imageSize = 'regular',
  moveIn = null,
  moveOut = null,
  typePosition = 'bottom',
  photos = [],
  carouselRatio = RATIOS.HOMECARD
}) => {
  const imageContainerClassName = classnames(
    styles[`${baseClassName}__image-container`],
    styles[`${baseClassName}__image-container--${imageSize}`],
    {
      [styles[`${baseClassName}__image-container--round`]]: photos.length > 0
    }
  );

  const hasDates = moveIn && moveOut;
  const isTypePositionTop = typePosition === 'top';

  const contentClasses = classnames(styles[`${baseClassName}__content`], {
    [styles[`${baseClassName}__content--type-top`]]: isTypePositionTop
  });

  const typeClasses = classnames(styles[`${baseClassName}__type`], {
    [styles[`${baseClassName}__type--upper-case`]]: isTypePositionTop
  });

  const sliderClasses = classnames(
    styles[`${baseClassName}__image`],
    styles[`${baseClassName}__chevron`]
  );

  const shouldRenderContent =
    title || rating || hasDates || (type && !hasDates);

  const onImageClick = () => {
    SoyuzAnalytics.sendGA4Event('homecard-image-slide', {
      action: 'click',
      section: 'booking-request-cancellation'
    });
  };
  const onImageChange = () => {
    SoyuzAnalytics.sendGA4Event('homecard-image-slide', {
      action: 'swipe',
      section: 'booking-request-cancellation'
    });
  };
  return (
    <div className={classnames(styles[baseClassName], className)}>
      {shouldRenderContent && (
        <div className={contentClasses}>
          {type && !hasDates && isTypePositionTop && (
            <div className={typeClasses}>{trans(`homecard.type.${type}`)}</div>
          )}
          {title && (
            <span className={styles[`${baseClassName}__title`]}>{title}</span>
          )}
          {type && !hasDates && !isTypePositionTop && (
            <div className={typeClasses}>{trans(`homecard.type.${type}`)}</div>
          )}
          {rating && rating >= 3 && (
            <div>
              <Rating rating={rating} size="small" />
            </div>
          )}
          {hasDates ? (
            <div className={styles[`${baseClassName}__dates`]}>
              <CalendarWhiteBlack />
              <span>
                {moveIn} -&gt; {moveOut}
              </span>
            </div>
          ) : null}
        </div>
      )}

      <div className={imageContainerClassName}>
        {photos.length > 0 ? (
          <ImageCarousel
            className={sliderClasses}
            items={photos}
            withBackgroundChevrons
            lazyLoad
            keepHeightWhileLoading
            ratio={carouselRatio}
            onImageChange={onImageChange}
            onImageClick={onImageClick}
          />
        ) : (
          <img
            className={styles[`${baseClassName}__image`]}
            alt={title}
            src={photo}
          />
        )}
      </div>
    </div>
  );
};

HomeSummary.propTypes = {
  title: PropTypes.string,
  photo: PropTypes.string,
  photos: PropTypes.arrayOf(PropTypes.shape({ src: PropTypes.string })),
  type: PropTypes.oneOf(['apartment', 'residence', 'room_shared', 'studio']),
  typePosition: PropTypes.oneOf(['top', 'bottom']),
  rating: PropTypes.number,
  className: PropTypes.string,
  imageSize: PropTypes.oneOf(['small', 'regular', 'full-width']),
  moveIn: PropTypes.string,
  moveOut: PropTypes.string,
  carouselRatio: PropTypes.oneOf(Object.values(RATIOS))
};

export default HomeSummary;
